import React from 'react';

export const StepSuccessfulAside = () => (
  <>
    <div className="px-8 pt-14 pb-28 bg-[#101733] relative">
      <div className="flex items-center space-x-2 mb-10">
        <a href="/professionals" className="text-[#007DD1]">
          <img src="/img/pure-reg.svg" alt="Logo" />
        </a>
      </div>

      <p className="text-[#007DD1] text-base font-semibold pb-3">Register</p>

      <h2 className="text-[#F3F4F8] text-2xl font-semibold pb-3">
          Submission complete
      </h2>

      <p className="text-[#E1E4F5] text-base font-450 pb-8">
          Your registration has been submitted, we will be in touch shortly.
      </p>
    </div>

    <div
      className="relative bg-[#101733] w-full h-32 flex flex-col justify-center items-center"
      style={{
        clipPath: 'ellipse(60% 40% at 50% 10%)',
      }}
    >
    </div>
  </>
);
